export const masterFormList = [
    {
        id: 1,
        translationKey: "preciseLocation",
        path: "preciseLocation",
    },
    {
        id: 2,
        translationKey: "startVisit",
        path: "startVisit",
    },
];
